import React from 'react';
import FilterDispatcher from './filters/FilterDispatcher';

export default function RecordsFilterRow({ columns, filters, onFilterChange, onApplyFilters, onClearFilters, users, procesos, positions }) {
  return (
    <tr className="cm-filter-row">
      <th colSpan="2" style={{ verticalAlign: 'top', padding: '6px 4px', minWidth: 80 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <button
            className="cm-filter-btn cm-filter-btn--primary"
            onClick={onApplyFilters}
          >
            Filtrar
          </button>
          <button
            className="cm-filter-btn cm-filter-btn--cancel"
            onClick={onClearFilters}
          >
            Limpiar
          </button>
        </div>
      </th>
      {columns.map(col => (
        <th key={col.id}>
          {col.filterable !== false ? (
            <FilterDispatcher
              column={col}
              value={filters[col.id]?.value || ''}
              operator={filters[col.id]?.operator || ''}
              onChange={(val, op) => onFilterChange(col.id, val, op)}
              onApply={onApplyFilters}
              users={users}
              procesos={procesos}
              positions={positions}
            />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <div className="cm-filter-placeholder" />
              <div className="cm-filter-placeholder" />
            </div>
          )}
        </th>
      ))}
    </tr>
  );
}
